import { IAppConfig } from './app.config.d';

const appConfig: IAppConfig = {
	urls: {
		backend: {
			login: '/auth/login',
			refreshToken: '/oauth/token',
		},
		frontend: {
			baseUrlToIncludeInEmail: 'http://localhost:3000',
			confirmEmail: '/account/confirm-email',
			signIn: '/sign-in',
			signUp: '/sign-up',
			forgotPassword: '/account/forgot-password',
			resendConfirmationEmail: '/account/resend-confirmation-email',
		},
	},
};

const frontendUrl = appConfig.urls.frontend;

export const urlsToWhichNotReturn = [
	frontendUrl.forgotPassword,
	frontendUrl.signUp,
	frontendUrl.signIn,
	frontendUrl.confirmEmail,
	frontendUrl.resendConfirmationEmail,
];

export default appConfig;
